var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",attrs:{"id":"app"}},[_c('FulfillingBouncingCircleSpinner',{attrs:{"animation-duration":1800,"size":_vm.size,"color":"#49b4ed"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }